<template>
    <div class="flex flex-col mb-4 bg-white shadow-xl rounded-2xl border-box">
        <div
            class="flex rounded-t-lg"
        >
            <img
                :src="bookDetails['cover_photo_url']"
                class="box-border rounded-t-lg"
            />
        </div>
        <section
            class="flex flex-col w-full p-4 border-0 border-solid rounded-2xl border-box md:text-xl"
        >
            <header class="box-border pb-1 text-lg font-bold text-pink-700">
                {{ bookDetails["title"] }}
            </header>
            <main class="flex flex-row text-base text-black grow md:text-sm md:gap-4 cust-min-height">
                <div class="text-justify grow">
                    {{
                    bookDetails["description"]
                    ? bookDetails["description"].substr(0, 500)
                    : ""
                    }}
                    {{ bookDetails["description"].substr(501) ? "...." : "" }}
                </div>
                <div class="flex items-center justify-center">

                </div>
            </main>
        </section>
        <div class="px-4 pb-6 bg-white rounded-b-lg w-fiull">
            <div class="flex items-start justify-start">
                <span class="px-4 py-1 italic font-semibold text-pink-600 border-2 border-pink-600 border-solid rounded-xl hover:bg-pink-600 hover:text-white">ascolta</span>
                <!-- <img src="/img/icons/arrow_to_right.svg" class="h-4 border-2 border-pink-600 border-solid rounded-full aspect-square"> -->
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            bookDetails: {
                type: Object,
                required: true,
            },
        },
        emits: ["cardClicked"],
    };
</script>
<style scoped>
    .cust-min-height {
        min-height: 9rem;
    }
</style>